import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as commonActions from '@common/common.action';
import ProtocoloContainer from '@common/protocolo/protocolo.container';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import IntlMessage from '../../../../../helpers/intlMessage';

class RequisicaoImunoModal extends Component {
  render() {
    return (
      <div className='mv-container-faturamento'>
        <Modal size='xl' isOpen={this.props.isOpen} toggle={this.props.toggle}>
          <ModalHeader>
            {<IntlMessage id = "dashboards.examDetail.protocolRequirements"/>} {`${this.props.laudo}`}
          </ModalHeader>
          <ModalBody>
            <ProtocoloContainer laudo={this.props.laudo} />
          </ModalBody>
          <ModalFooter>
            <Button
              className='modalComponente-fechar'
              color='secondary'
              onClick={this.props.toggle}
            >
              <IntlMessage id = "dashboards.examDetails.cancel"/>
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    laudo: state.commonReducer.laudo,
    modalRequisicaoImuno: state.commonReducer.modalRequisicaoImuno,
  };
};

const mapDispacthToProps = (dispatch) => {
  return {
    commonActions: bindActionCreators(commonActions, dispatch),
  };
};

export default connect(
  mapStateToProps,
  mapDispacthToProps
)(RequisicaoImunoModal);



// WEBPACK FOOTER //
// ./src/pages/main/listagem/modais/requisicaoimuno/requisicao.imuno.modal.js